/* ============================================================================
   NAVEGACIÓN POR PÁGINAS + PROMO HERO 3
   ============================================================================ */
(function(){
  "use strict";
  var catHero=document.getElementById('catHero'), howto=document.getElementById('howto');
  var catIntro=document.getElementById('catIntro');
  var SEC={
    hero:document.querySelector('.hero'),
    season:document.querySelector('.season'),
    reviews:document.querySelector('.reviews'),
    finder:document.getElementById('finder'),
    best:document.getElementById('bestsellers'),
    catalogo:document.getElementById('catalogo'),
    values:document.querySelector('.values'),
    story:document.querySelector('.story'),
    nuevos:document.getElementById('nuevos')
  };
  var divisores=[].slice.call(document.querySelectorAll('.divider'));

  var RUTAS={
    'disenadores' :{t:'Diseñadores',        e:'Todas las casas', ver:['catalogo'],
                    s:'El catálogo completo, ordenado por la casa que inspira cada aroma'},
    'caballero'   :{t:'Caballero',          e:'Colección', para:'Caballero',  ver:['catalogo'], promo:true},
    'dama'        :{t:'Dama',               e:'Colección', para:'Dama',       ver:['catalogo'], promo:true},
    'unisex'      :{t:'Unisex',             e:'Colección', para:'Unisex',     ver:['catalogo'], promo:true},
    'ambientales' :{t:'Ambientales',        e:'Colección', para:'Ambiental',  ver:['catalogo'],
                    s:'Aromas para tu espacio'},
    'best-sellers':{t:'Best Sellers',       e:'Los favoritos', ver:['best'],
                    s:'Las fragancias más elegidas por nuestros clientes en Hermosillo'},
    'novedades'   :{t:'Novedades 2026',     e:'Recién llegados', ver:['nuevos'],
                    s:'Las incorporaciones más recientes a la colección Velantis'},
    'encuentra-tu-aroma':{t:'Encuentra tu nuevo aroma', e:'Asesoría olfativa', ver:['finder','catalogo'],
                    howto:true, s:'Elige tus notas favoritas y descubre tu fragancia ideal'}
  };

  var PROMO_TITLES={
    caballero:{title:'Presencia que se impone', desc:'Aromas de estructura firme para el hombre que no necesita anunciar su llegada.'},
    dama:{title:'Seducción en silencio', desc:'Fragancias envolventes que lo acompañan del día a la noche sin pedir permiso.'},
    unisex:{title:'Carácter sin género', desc:'Notas versátiles que se adaptan a la piel y a la ocasión, no a una etiqueta.'}
  };

  function soltarFiltros(){
    var s=document.getElementById('catCasa');
    if(s && s.value){ s.value=''; s.dispatchEvent(new Event('change',{bubbles:true})); }
    var f=document.getElementById('ccFiltros');
    if(f){
      var p=f.querySelector('button[data-para].on'); if(p) p.click();
      var t=f.querySelector('button[data-tipo]:not([data-tipo=""]).on');
      if(t){ var todo=f.querySelector('button[data-tipo=""]'); if(todo) todo.click(); }
    }
    var q=document.getElementById('ccQ'), x=document.getElementById('ccX');
    if(q && q.value && x) x.click();
  }

  function mostrarTodo(v){
    Object.keys(SEC).forEach(function(k){ if(SEC[k]) SEC[k].hidden=!v; });
    divisores.forEach(function(d){ d.hidden=!v; });
    if(v) document.querySelectorAll('.sec-head[hidden]').forEach(function(sh){ sh.hidden=false; });
  }

  function renderVortex(route){
    var data=ph3Data && ph3Data[route]; if(!data) return;
    var vortex=document.getElementById('ph3Vortex'); if(!vortex) return;
    vortex.innerHTML='';
    for(var i=0;i<9;i++){
      var n=document.createElement('div'); n.className='ph3-note';
      n.style.left='50%'; n.style.top='50%';
      n.className='ph3-note ph3-note-'+(i%3);
      var size=120+Math.random()*60;
      n.style.width=size+'px'; n.style.height=size+'px';
      n.style.animationDelay='-'+(i*2.5)+'s';
      n.style.animationDuration=(18+Math.random()*8)+'s';
      vortex.appendChild(n);
    }
  }

  function renderLegend(route){
    var data=ph3Data && ph3Data[route]; if(!data) return;
    var leg=document.getElementById('ph3Legend'); if(!leg) return;
    leg.innerHTML='';
    data.names.forEach(function(name){
      var s=document.createElement('span');
      s.innerHTML='<i></i>'+name;
      leg.appendChild(s);
    });
  }

  function renderPromo(route){
    var data=ph3Data && ph3Data[route]; if(!data) return;
    document.getElementById('chEyebrow').textContent='Colección · '+data.eyebrow;
    document.getElementById('ciEyebrow').innerHTML='Colección · <span id="ciPara">'+data.eyebrow+'</span>';
    var t=PROMO_TITLES[route];
    document.getElementById('ciTitle').textContent=t.title;
    document.getElementById('ciDesc').textContent=t.desc;
    renderVortex(route);
    renderLegend(route);
  }

  function clearPromo(){
    var vortex=document.getElementById('ph3Vortex'); if(vortex) vortex.innerHTML='';
    var leg=document.getElementById('ph3Legend'); if(leg) leg.innerHTML='';
  }

  var ph3Data=null;
  function loadPh3Data(){
    if(ph3Data) return;
    var s=document.getElementById('ph3Notes');
    if(s) try{ ph3Data=JSON.parse(s.textContent); }catch(e){ ph3Data={}; }
  }

  function ir(){
    var hash=location.hash||'';
    soltarFiltros();
    if(hash.indexOf('#/')!==0){
      document.body.classList.remove('ruta'); document.body.removeAttribute('data-ruta');
      catHero.hidden=true; howto.hidden=true; catIntro.hidden=true; clearPromo();
      mostrarTodo(true);
      if(window.VelantisCatalogo) window.VelantisCatalogo.setPara('');
      return;
    }
    var clave=hash.slice(2).replace(/\/$/,'');
    var r=RUTAS[clave];
    if(!r){
      document.body.classList.remove('ruta'); document.body.removeAttribute('data-ruta');
      catHero.hidden=true; howto.hidden=true; catIntro.hidden=true; clearPromo();
      mostrarTodo(true);
      if(window.VelantisCatalogo) window.VelantisCatalogo.setPara('');
      window.scrollTo(0,0);
      return;
    }
    document.body.classList.add('ruta');
    document.body.setAttribute('data-ruta', clave);
    mostrarTodo(false);
    r.ver.forEach(function(k){ if(SEC[k]) SEC[k].hidden=false; });
    catHero.hidden=true;
    catIntro.hidden=false;
    howto.hidden=!r.howto;

    loadPh3Data();
    if(r.promo){
      renderPromo(clave);
    } else {
      clearPromo();
      document.getElementById('chEyebrow').textContent=r.e;
      document.getElementById('chTitle').textContent=r.t;
      var n=(r.para && window.VelantisCatalogo)? window.VelantisCatalogo.count(r.para):0;
      document.getElementById('chSub').textContent = r.para
        ? n+' fragancias · precio único $449 MXN'
        : (r.s||'');
      document.getElementById('ciEyebrow').textContent=r.e||'';
      document.getElementById('ciTitle').textContent=r.t||'';
      document.getElementById('ciDesc').textContent=r.s||'';
      document.getElementById('ciPills').innerHTML='';
    }

    if(window.VelantisCatalogo) window.VelantisCatalogo.setPara(r.para||'');
    r.ver.forEach(function(k,idx){
      var sh=SEC[k]&&SEC[k].querySelector('.sec-head'); if(sh) sh.hidden=(idx===0);
    });
    document.title='Velantis · '+r.t;
    window.scrollTo(0,0);
  }

  window.addEventListener('hashchange',ir);
  ir();
})();
